// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"629":"9bbb746c","766":"31d6cfe0"}[chunkId] + ".chunk.css";
};